import {
  MessageWidget,
  ClockWidget,
  ShiftsTodayWidget,
  UncoveredShiftsWidget,
  EpcrStatsWidget,
  FleetReadinessWidget,
  PtsTodayWidget,
  CqcReadinessWidget,
} from './coreWidgets'
import { ShoutoutsWidget, OnDutyWidget, UpcomingEventsWidget } from './listWidgets'
import { ShiftsTrendWidget, EpcrTrendWidget } from './chartWidgets'
import KpiWidget from './KpiWidget'

// Single source for both the display renderer and the editor's widget picker.
// `type` keys must match the server registry (helpers/wallboard/widgetData.js)
// or the config routes reject the board. Sizes are grid spans on a 4-column
// grid: 'CxR' = C columns wide, R rows tall.
export const WIDGET_REGISTRY = {
  shoutouts: {
    label: 'Shoutouts',
    description: 'Recent recognition sent between colleagues.',
    component: ShoutoutsWidget,
    sizes: ['2x2', '2x1', '4x2'],
    defaultSize: '2x2',
  },
  message: {
    label: 'Message',
    description: 'A fixed announcement or message of the day.',
    component: MessageWidget,
    sizes: ['1x1', '2x1', '4x1'],
    defaultSize: '2x1',
    configFields: [
      { key: 'title', label: 'Heading', type: 'text' },
      { key: 'text', label: 'Message', type: 'multiline' },
    ],
  },
  clock: {
    label: 'Clock',
    description: 'Large time and date.',
    component: ClockWidget,
    sizes: ['1x1', '2x1'],
    defaultSize: '1x1',
  },
  onDutyNow: {
    label: 'On duty now',
    description: 'Who is on shift right now, with their roles.',
    component: OnDutyWidget,
    sizes: ['2x1', '2x2', '4x1'],
    defaultSize: '2x2',
  },
  shiftsToday: {
    label: 'Shifts today',
    description: "Today's shift count and who's on duty.",
    component: ShiftsTodayWidget,
    sizes: ['1x1', '2x1'],
    defaultSize: '1x1',
  },
  uncoveredShifts: {
    label: 'Uncovered shifts',
    description: 'Unassigned shifts in the next 7 days — amber when above zero.',
    component: UncoveredShiftsWidget,
    sizes: ['1x1', '2x1'],
    defaultSize: '1x1',
  },
  shiftsTrend: {
    label: 'Shifts per week',
    description: 'Weekly shift volume over the last 8 weeks.',
    component: ShiftsTrendWidget,
    sizes: ['2x1', '4x1', '2x2'],
    defaultSize: '2x1',
  },
  epcrStats: {
    label: 'Patient records',
    description: 'ePCRs completed in the last 30 days (count only).',
    component: EpcrStatsWidget,
    sizes: ['1x1', '2x1'],
    defaultSize: '1x1',
  },
  epcrTrend: {
    label: 'Patient records trend',
    description: 'ePCRs per month over the last 6 months (counts only).',
    component: EpcrTrendWidget,
    sizes: ['2x1', '4x1', '2x2'],
    defaultSize: '2x1',
  },
  fleetReadiness: {
    label: 'Fleet readiness',
    description: 'Operational vs off-road vehicles and open defects.',
    component: FleetReadinessWidget,
    sizes: ['2x1', '1x1'],
    defaultSize: '2x1',
  },
  kpi: {
    label: 'KPI section',
    description: "A KPI section's headline tiles and health score.",
    component: KpiWidget,
    sizes: ['2x1', '2x2', '4x1'],
    defaultSize: '2x1',
    configFields: [{ key: 'slug', label: 'KPI section', type: 'kpiSlug' }],
  },
  upcomingEvents: {
    label: 'Upcoming events',
    description: 'Next events with their crewing status.',
    component: UpcomingEventsWidget,
    sizes: ['2x2', '2x1'],
    defaultSize: '2x2',
  },
  ptsToday: {
    label: 'PTS today',
    description: "Today's patient transport journeys (counts only).",
    component: PtsTodayWidget,
    sizes: ['1x1', '2x1'],
    defaultSize: '2x1',
  },
  cqcReadiness: {
    label: 'CQC readiness',
    description: 'Overall CQC readiness score.',
    component: CqcReadinessWidget,
    sizes: ['1x1'],
    defaultSize: '1x1',
  },
}

export const widgetSpan = (size = '1x1') => {
  const [cols, rows] = size.split('x').map(Number)
  return { cols: cols || 1, rows: rows || 1 }
}
